/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../root/RootReducer";
import { GetVideoSlide } from "../../../common/video/VideoActions";
import styles from "./SlideHover.module.css";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "./reactPdf.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { VideoPDF } from "../../../common/video/models/Video";

import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { createStyles, Fab, makeStyles, Theme } from "@material-ui/core";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


interface SlideHoverProps {
  in: boolean;
  onEnter?: () => {};
  onExited?: () => {};
  // ビデオID
  videoId: string;
  onClose?: () => void;
}

const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    icon: {
      marginLeft: "5px",
      marginTop: "5px",
      backgroundColor: "rgb(255, 255, 255, 0.7)",
      "&:hover": {
        backgroundColor: "rgb(255, 255, 255, 0.9)",
      },
    },
  })
);

const SlideHover = React.forwardRef<HTMLDivElement, SlideHoverProps>(
  function SlideHover(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { videoPdf } = useSelector((state: AppState) => ({
      videoPdf: state.video.videoPdf,
    }));

    const [slides, setSlides] = useState<VideoPDF>();
    const [heightMode, setHeightMode] = useState(false);

    const [numPages, setNumPages] = useState<number>(1);
    function onDocumentLoadSuccess({ numPages }) {
      setNumPages(numPages);
    }

    // PDFスライドを取得
    useEffect(() => {
      if (props.videoId) {
        // TODO: temp fileID
        dispatch(GetVideoSlide(props.videoId, "1"));
      }
    }, [dispatch, props.videoId]);

    useEffect(() => {
      if (videoPdf) {
        setSlides(videoPdf);
        setNumPages(videoPdf.videoSlides.length);
      }
    }, [videoPdf]);

    // スライド資料の高さをチェック
    function checkHeight(index: number) {
      let child = document.getElementById(`page_${index}`)?.firstElementChild;
      let canvas = child?.firstElementChild;
      let width = canvas?.getAttribute("width");
      let height = canvas?.getAttribute("height");
      if (Number(height) > Number(width) && !heightMode) {
        setHeightMode(true);
      }
    }

    function previousPage(event: React.MouseEvent<HTMLButtonElement>) {
      event.stopPropagation()
      const scrollContainer = document.querySelector("#slideArea");
      if (heightMode) {
        if (scrollContainer) scrollContainer.scrollLeft -= 425;
      } else {
        if (scrollContainer) scrollContainer.scrollLeft -= 780;
      }
    }
    function nextPage(event: React.MouseEvent<HTMLButtonElement>) {
      event.stopPropagation()
      const scrollContainer = document.querySelector("#slideArea");
      if (heightMode) {
        if (scrollContainer) scrollContainer.scrollLeft += 425;
      } else {
        if (scrollContainer) scrollContainer.scrollLeft += 780;
      }
    }

    return (
      <div id="slideArea" className={styles.slideArea} onClick={props.onClose}>

        {slides !== undefined && (
          <Document
            file={slides.slideUrl}
            onLoadSuccess={onDocumentLoadSuccess}
            options={{
              cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
              cMapPacked: true,
            }}
          >
            <div>
              <Swiper
                spaceBetween={3}
                loop={false}
                navigation={{
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                }}
                initialSlide={0}
                virtualTranslate={true}
              >
                {Array.from(new Array(numPages), (el, index) => (
                  <SwiperSlide
                    id={`page_${index + 1}`}
                    key={`recordSlide-${index}`}
                    className={
                      heightMode ? styles.heightSlideImg : styles.slideImg
                    }
                  >
                    <Page
                      key={`page_${index + 1}`}
                      pageNumber={index + 1}
                      className={
                        heightMode ? styles.heightSlidePage : styles.slidePage
                      }
                      renderAnnotationLayer={false}
                      onRenderSuccess={() => checkHeight(index + 1)}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
            <Fab
              variant="circular"
              size="small"
              className={classes.icon}
              style={{ position: "fixed", right: "52%" }}
              onClick={previousPage}
            >
              <NavigateBeforeIcon style={{ color: "var(--red)" }} />
            </Fab>
            <Fab
              variant="circular"
              size="small"
              className={classes.icon}
              style={{ position: "fixed", left: "52%" }}
              onClick={nextPage}
            >
              <NavigateNextIcon style={{ color: "var(--red)" }} />
            </Fab>
          </Document>
        )}
      </div>
    );
  }
);
export default SlideHover;
